var map = {
	"./⏲ Appliances.svg": 4792,
	"./⚽️ Sports & Outdoors.svg": 8837,
	"./✈️ Luggage & Travel Gear.svg": 483,
	"./❓ Unknown.svg": 7062,
	"./🌱 Garden & Outdoors.svg": 9341,
	"./🎬 Movies & TV.svg": 7099,
	"./🎮 Video Games.svg": 4116,
	"./🎵 Musical Instruments.svg": 1909,
	"./🏠 Home & Kitchen.svg": 9235,
	"./🏥 Health, Household & Baby Care.svg": 1554,
	"./🐶 Pet Supplies.svg": 9381,
	"./👚 Clothing, Shoes, Jewelry.svg": 4693,
	"./👶 Baby.svg": 493,
	"./👾 Apps & Games.svg": 3150,
	"./💄 Beauty and Personal Care.svg": 5629,
	"./💻 Computers.svg": 1932,
	"./💿 CD & Vinyls.svg": 9440,
	"./📈 Industrial & Scientific.svg": 7918,
	"./📌 Office Products.svg": 5653,
	"./📖 Kindle.svg": 4646,
	"./📚 Books.svg": 586,
	"./📱 Cell Phones & Accessories.svg": 4677,
	"./📷 Electronics.svg": 7988,
	"./🖼  Collectibles & Fine Art.svg": 8546,
	"./🚗  Automotive Parts & Accessories.svg": 2652,
	"./🛒 Grocery & Gourmet Food.svg": 6254,
	"./🛠 Tools & Home Improvement.svg": 4149,
	"./🤖 Toys & Games.svg": 9477,
	"icons/Category Icons Assets/⏲ Appliances.svg": 4792,
	"icons/Category Icons Assets/⚽️ Sports & Outdoors.svg": 8837,
	"icons/Category Icons Assets/✈️ Luggage & Travel Gear.svg": 483,
	"icons/Category Icons Assets/❓ Unknown.svg": 7062,
	"icons/Category Icons Assets/🌱 Garden & Outdoors.svg": 9341,
	"icons/Category Icons Assets/🎬 Movies & TV.svg": 7099,
	"icons/Category Icons Assets/🎮 Video Games.svg": 4116,
	"icons/Category Icons Assets/🎵 Musical Instruments.svg": 1909,
	"icons/Category Icons Assets/🏠 Home & Kitchen.svg": 9235,
	"icons/Category Icons Assets/🏥 Health, Household & Baby Care.svg": 1554,
	"icons/Category Icons Assets/🐶 Pet Supplies.svg": 9381,
	"icons/Category Icons Assets/👚 Clothing, Shoes, Jewelry.svg": 4693,
	"icons/Category Icons Assets/👶 Baby.svg": 493,
	"icons/Category Icons Assets/👾 Apps & Games.svg": 3150,
	"icons/Category Icons Assets/💄 Beauty and Personal Care.svg": 5629,
	"icons/Category Icons Assets/💻 Computers.svg": 1932,
	"icons/Category Icons Assets/💿 CD & Vinyls.svg": 9440,
	"icons/Category Icons Assets/📈 Industrial & Scientific.svg": 7918,
	"icons/Category Icons Assets/📌 Office Products.svg": 5653,
	"icons/Category Icons Assets/📖 Kindle.svg": 4646,
	"icons/Category Icons Assets/📚 Books.svg": 586,
	"icons/Category Icons Assets/📱 Cell Phones & Accessories.svg": 4677,
	"icons/Category Icons Assets/📷 Electronics.svg": 7988,
	"icons/Category Icons Assets/🖼  Collectibles & Fine Art.svg": 8546,
	"icons/Category Icons Assets/🚗  Automotive Parts & Accessories.svg": 2652,
	"icons/Category Icons Assets/🛒 Grocery & Gourmet Food.svg": 6254,
	"icons/Category Icons Assets/🛠 Tools & Home Improvement.svg": 4149,
	"icons/Category Icons Assets/🤖 Toys & Games.svg": 9477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3290;